import { render, staticRenderFns } from "./NewsAppPushMessagesListTable.vue?vue&type=template&id=796238a3"
import script from "./NewsAppPushMessagesListTable.js?vue&type=script&lang=js&external"
export * from "./NewsAppPushMessagesListTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports